var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconionicmdeyeoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.536,
    height: 15.027,
    viewBox: "0 0 17.536 15.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-eye-off",
    "data-name": "Icon ionic-md-eye-off",
    d: "M11.02,7.662a3.975,3.975,0,0,1,3.988,3.956,3.806,3.806,0,0,1-.286,1.448l2.328,2.309a9.355,9.355,0,0,0,2.735-3.757A9.444,9.444,0,0,0,7.838,6.238L9.56,7.948A3.943,3.943,0,0,1,11.02,7.662ZM3.048,5.506l1.82,1.8.368.364A9.311,9.311,0,0,0,2.25,11.618a9.458,9.458,0,0,0,12.26,5.267l.337.333,2.336,2.309L18.2,18.521,4.058,4.5ZM7.455,9.877,8.691,11.1a2.242,2.242,0,0,0-.063.513,2.379,2.379,0,0,0,2.391,2.371,2.249,2.249,0,0,0,.517-.063l1.237,1.225a3.967,3.967,0,0,1-5.741-3.538A3.909,3.909,0,0,1,7.455,9.877Zm3.436-.614L13.4,11.755l.016-.125a2.379,2.379,0,0,0-2.391-2.371Z",
    transform: "translate(-2.25 -4.5)",
    fill: "#1b3e6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicmdeyeoff);
export default __webpack_public_path__ + "static/media/Iconionicmdeyeoff.15c2d03c24a30d791c2260d0b0c240d4.svg";
export { ForwardRef as ReactComponent };